import { Coin2 } from '@hungryroot/icons';
import { Paragraph, Heading } from '@hungryroot/ramen';
import styles from './PointsWithIcon.module.css';

export enum PointsWithIconVariant {
  Default = 'default',
  Large = 'large',
  Removed = 'removed',
}

interface Props {
  testid?: string;
  points: string;
  ariaLabel?: string;
  variant?: PointsWithIconVariant;
  className?: string;
  containerClassName?: string;
}

export function PointsWithIcon(props: Props) {
  const {
    ariaLabel,
    testid,
    points,
    variant = PointsWithIconVariant.Default,
    className,
    containerClassName,
  } = props;

  const pointsContent = (
    <>
      <Coin2 />
      <span
        data-testid={`${testid}`}
        className={className}
        aria-label={ariaLabel}
      >
        {points === 'FREE' ? 'FREE' : parseFloat(points)}
      </span>
    </>
  );

  if (variant === PointsWithIconVariant.Default) {
    return <span className={styles.container}>{pointsContent}</span>;
  }

  if (variant === PointsWithIconVariant.Large) {
    return (
      <Heading
        className={`${styles.large} ${containerClassName}`}
        variant="H6"
        testid={`${testid}-large`}
      >
        {pointsContent}
      </Heading>
    );
  }

  return (
    <Paragraph
      aria-label={ariaLabel}
      className={styles.removed}
      variant="caption"
      testid={`${testid}-removed`}
    >
      {pointsContent}
    </Paragraph>
  );
}
